import { Loader } from '@fountain/fountain-ui-components';
import { ButtonBase, InputLabel } from '@material-ui/core';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import cx from 'classnames';
import React, { FC, useState } from 'react';

import { QuestionLayout } from '../../components/QuestionLayout/QuestionLayout';
import { Typography } from '../../components/Typography';
import { ImageViewer } from './ImageViewer';
import { useStyles } from './styles';

export interface QuestionWithMediaProps {
  hint?: React.ReactNode;
  question: string;
  id: string;
  required?: boolean;
  dense?: boolean;

  imageUrl?: string;
  children?: React.ReactNode;
}

export const QuestionWithMedia: FC<QuestionWithMediaProps> = ({
  id,
  hint,
  question,
  children,
  required,
  dense,
  imageUrl,
}) => {
  const [loading, setLoading] = useState(true);
  const styles = useStyles();
  const [isFullscreen, setIsFullscreen] = useState(false);

  return (
    <>
      <QuestionLayout
        input={children}
        question={
          <div className={styles.questionWithMediaContainer}>
            <div className={styles.titleContainer}>
              <InputLabel htmlFor={id}>
                <Typography
                  {...(!dense && { variant: 'headingMD' })}
                  className={cx(styles.questionText, {
                    [styles.required]: required,
                  })}
                >
                  {question}
                </Typography>
              </InputLabel>
            </div>
            {imageUrl && (
              <div className={styles.mediaWrapper}>
                <div className={styles.questionImageContainer}>
                  <img
                    src={imageUrl}
                    alt="Assessment question visual aid"
                    className={styles.questionImageImg}
                    style={{ display: 'none' }}
                    onLoad={() => setLoading(false)}
                  />

                  {loading ? (
                    <div className={styles.loaderContainer}>
                      <Loader fullSection size="1.5rem" />
                    </div>
                  ) : (
                    <ButtonBase
                      component="div"
                      className={styles.questionImageContainer}
                      onClick={() => setIsFullscreen(true)}
                    >
                      <img
                        src={imageUrl}
                        alt="Assessment question visual aid"
                        className={styles.questionImageImg}
                      />
                      <div className={styles.fullscreenButton}>
                        <FullscreenIcon />
                      </div>
                    </ButtonBase>
                  )}
                </div>
              </div>
            )}
          </div>
        }
        hint={hint}
        dense={dense}
      />
      {isFullscreen && imageUrl && (
        <ImageViewer src={imageUrl} onClose={() => setIsFullscreen(false)} />
      )}
    </>
  );
};
